module.exports = __webpack_public_path__ + "static/media/logoEyeFlowNameless4.51908118.png";